import styled from 'styled-components'
import ArticleCard from '@otavamedia/om-component-library/lib/ArticleCard'
import React, { Component } from 'react'
import HTMLParser from '@otavamedia/om-component-library/lib/lib/html-parser'
import { IMAGE_SIZE } from '@otavamedia/om-component-library/lib/entities/ImageModel'
import get from 'lodash/get'
import PropTypes from 'prop-types'

const ProductCard = styled(ArticleCard)`
  height: 100%;
  > div:first-child {
    height: 175px;
    overflow: hidden;
  }
  &:hover {
    h2, .topic {
      transition: color 0.1s ease;
      color: #565e70;
    }
  }
  video {
    display: block;
  }

  & .image-container {
    height: 190px;
    border-bottom: 4px solid #00091e;
  }

  & .card-image {
    height: 100%;
    object-fit: cover;
  }

  & .topic {
    text-transform: uppercase;
    font-size: 0.75rem;
    margin: 0.5rem 0;
  }

  & h2 {
    font-size: 20px;
    line-height: 24px;
    margin: 0 0 0.5rem 0;
    transition: color 0.1s ease;
  }
  .card-meta {
    font-family: "Gotham-Black";
    text-transform: uppercase;
    font-size: 12px;
    line-height: 1rem;
    color: #8c9696;
    padding: 1rem;
    padding-bottom: 0;
    justify-content: space-between;

    li {
      margin: 0;
      color: #484e5d;
    }
    .right-column {
      text-transform: none;
    }
  }
  .printmag {
    position: absolute;
    background: red;
    color: white;
    left: 38%;
    top: 165px;
    font-size: 10px;
    font-weight: 500;
    line-height: 16px;
    padding: 0 5px;
  }
  .printmag::before {
    content: '';
    background-image: url('/assets/logos/site-logo.svg');
    background-repeat: no-repeat;
    height: 13px;
    width: 21px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 0;
  }
  .grade {
    background: #009fe3;
    padding: 6px;
    border-radius: 3px;
    font-size: 20px;
    line-height: 20px;
    position: absolute;
    right: 1.75rem;
    top: 1rem;
    color: white;
  }
`
const BestProductCard = styled(ProductCard)`
  text-align: center;

  .right-column {
    display: none
  }
  .card-meta {
    justify-content: center;
  }
  .card-content {
    padding-top: 0;
  }
`

export default class TestCard extends Component {
  static propTypes = {
    article: PropTypes.object.isRequired,
    notShown: PropTypes.object,
    isBest: PropTypes.bool,
  }

  static defaultProps = {
    notShown: {},
  }

  notALink = (props) => {
    return <div {...props}>{props.children}</div>
  }

  render () {
    const { isBest, article, notShown } = this.props
    const Card = isBest ? BestProductCard : ProductCard
    return <Card article={article}
      LinkComponent={this.notALink}
      htmlParser={HTMLParser.render}
      grade={get(article, 'linkedProductCards[0].productData.grade')}
      shown={{ printmag: true }}
      notShown={{ ...notShown, ingress: true, topic: true, createdDate: isBest }}
      categories={isBest ? [{ name: article.ingress }] : article.categories && article.categories.length ? [article.categories[0]] : undefined}
      displaySubscriberIcon={article.requiredSubscriptionLevel > 2} imageSize={IMAGE_SIZE.MEDIUM}
      sizes={'(min-width: 992px) 320px, (min-width: 768px) 50vw, 100vw'}/>
  }
}
